/* eslint-disable */
export default {
  currentCall: 'Llamada actual',
  viewCalls: 'Ver llamadas',
  view: 'Ver',
  incomingCall: '{numberOf}llamada entrante',
  incomingCalls: '{numberOf}llamadas entrantes',
  callOnHold: '{numberOf}llamada en espera',
  callsOnHold: '{numberOf}llamadas en espera',
  otherDeviceCall: '{numberOf}llamada a otros disp.',
  otherDeviceCalls: '{numberOf}llamadas a otros disp.',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
